// Import chart component internationalization
import echartsfn from "./echartsfn.js";

// Main large screen page content
const main = {
  // Page title and welcome information
  title: "Enter System",
  Platformcount: "Platform Data Statistics",
  PlatformcountUnit: "Billion",
  tagtotal: "Total Tags",
  malicetag: "Malicious Tags",
  Entitytag: "Entity Tags",
  behaviortag: "Behavior Tags",
  Maliciousmonitoring: "Malicious Address Risk Monitoring",
  TransferTrend: "Malicious Address Transfer Trend",
};

// Currency data page content
const currencydata = {
  // Page titles
  coinDataTitle: "Currency Data",
  coinDataUnit: "(Unit: USDT)",
  todayTransactionTitle: "Today's Large Transaction Monitoring",
  exchangeRankingsTitle: "Exchange 24H Trading Volume Rankings",

  // Data labels
  priceLabel: "Price",
  tradingVolumeLabel: "Trading Volume",
  tradingAddressLabel: "Trading Address",

  // Table headers
  rankLabel: "Rank",
  exchangeLabel: "Exchange",
  volume24hLabel: "24H Volume ($)",
  supportedCoinsLabel: "Supported Coins",

  // Status messages
  loadingText: "Loading...",
  noDataText: "No Data Available",

  // Transaction descriptions
  transferText: "Transfer",
  toText: "To",
  transferToText: "Transfer To",
};

// Graph Security page content
const graphSecurity = {
  // Page titles
  graphSecurityTitle: "Graph Chain Security",
  labReportTitle: "Laboratory Research Reports",

  // Tab labels
  phishingFraudTab: "Phishing Fraud",
  multiSignFraudTab: "Multi-Signature Fraud",

  // Chart titles
  fraudAddressCountTitle: "Phishing Fraud Victim Address Count",
  fraudAmountStatTitle: "Defrauded Amount Statistics",
  victimAddressCountTitle: "Victim Address Count",
  fraudFeeAddressActiveTitle: "Fraud Fee Address Activity",

  // Units
  addressCountUnit: "Item",
  amountUnit: "10K USDT",

  // Report titles
  phishingReportTitle: "Phishing Fraud Report",
  multiSignReportTitle: "Multi-Signature Authorization Fraud Report",

  // Report descriptions
  phishingReportDesc:
    "Graph Chain Security Laboratory investigates and discloses multi-signature authorization fraud on the Tron blockchain, revealing the specific methods used by fraud gangs, hoping to provide security warnings and recommendations to the public.",
  multiSignReportDesc:
    "Through monitoring and in-depth analysis of blockchain phishing fraud data, Graph Chain Security Laboratory found that attackers are becoming increasingly cunning in using highly similar addresses to disguise real addresses, making it easy for users to misjudge during transfers, resulting in asset losses.",
};

// Map page content
const mapPage = {
  // Case statistics labels
  caseJudgmentCountLabel: "[Case Count]",
  indictmentCountLabel: "[Indictment Count]",

  // Data description
  incompleteStatisticsTitle: "Incomplete Statistics",
};

export default {
  ...main,
  ...currencydata,
  ...graphSecurity,
  ...mapPage,
  ...echartsfn,
  // Sub-modules
};
